module.exports = __webpack_public_path__ + "static/media/Ivo.d002b0fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/Ivo.jpg
// module id = 1588
// module chunks = 146